import OTPForm from './OTPForm';
import OTP from './OTP';

export { OTP, OTPForm };
